import {useCallback} from 'react';
import {WebSocketOperationButton} from "../../components/web-socket/WebSocketOperationButton";
import {useKeyDataStore} from "../../api/KeyDataStore";
import {useKeyTagStore} from "../../api/KeyTagStore";
import {useKeyVaultStore} from "../../api/KeyVaultStore";
import {useCurrentOfficeStore} from "../../api/CurrentOfficeStore";
import {
    AMSTERDAM_OFFICE_ID,
    BELGRADE_OFFICE_ID,
    MUNICH_OFFICE_ID,
    PRAGUE_OFFICE_ID,
    YEREVAN_OFFICE_ID
} from "../../util/OfficePath";
import {OfficeIcon} from "../../components/office-icon/OfficeIcon";

const keyImportEnabledOffice = {
    [AMSTERDAM_OFFICE_ID]: false,
    [MUNICH_OFFICE_ID]: false,
    [PRAGUE_OFFICE_ID]: false,
    [YEREVAN_OFFICE_ID]: false,
    [BELGRADE_OFFICE_ID]: true,
};

export default function ImportKeysButton() {
    const currentOfficeId = useCurrentOfficeStore(state => state.officeId);
    const loadKeys = useKeyDataStore(state => state.refresh);
    const loadTags = useKeyTagStore(state => state.refresh);
    const loadVaults = useKeyVaultStore(state => state.refresh);

    const handleFinish = useCallback(() => {
        loadKeys();
        loadTags();
        loadVaults();
    }, [loadKeys, loadTags, loadVaults]);

    const visible: boolean | undefined = currentOfficeId != null && keyImportEnabledOffice[currentOfficeId];
    return currentOfficeId != null && visible != null ? (
        <WebSocketOperationButton
            endpoint={`/api/operations/offices/${currentOfficeId}/import-keys`}
            variant="outlined"
            description="Import keys from the Google spreadsheet into the local database."
            actionButtonLabel="Import Keys"
            icon={<OfficeIcon officeId={currentOfficeId} colored />}
            onFinish={handleFinish}
            sx={{display: visible ? undefined : 'none'}}
        />
    ) : null;
}
